<h5>Pedidos com erros na integração em mesas</h5>

<app-grid-pedidos #gridPedidos [pedidos]="pedidos" [carregando]="carregando" [mesa]="true" ></app-grid-pedidos>
